export const SelectAll = 'SelectAll';
